import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@tango/app/shared';
import { ComponentsModule } from '@tango/app/login/components.module';
import { BankLoginComponent } from './login.component';
import { OnscreenKeyboardService } from '@tango/app/login/onscreen-keyboard.service';
import { LoginService } from '@tango/app/login/login.service';
import { LoginRoutingModule } from './login.routing';
import { BankSimpleLoginFormComponent } from './simple-login-form';
import { BankResetInitialPasswordComponent } from './reset-initial-password-form';

@NgModule({
  imports: [CommonModule, SharedModule, ComponentsModule, LoginRoutingModule],
  declarations: [
    BankLoginComponent,
    BankSimpleLoginFormComponent,
    BankResetInitialPasswordComponent,
  ],
  providers: [LoginService, OnscreenKeyboardService],
})
export class BankLoginModule {}
